import * as RelocationOrderModels from '../../models/relocation-order/relocation-order';
import { RelocationOrderSearchModel } from '../../models/relocation-order/relocation-orderSearch';
import * as Models from '../../models/commonModels';
import * as TyreTakeoverOrderModels from '../../models/tyre-takeover-order/tyre-takeover-order';

export class GetList {
  static readonly type = '[RelocationOrder] List';
  constructor(public Search: RelocationOrderSearchModel) { }
}

export class SetSearch {
  static readonly type = '[RelocationOrder] Set Search';
  constructor(public Search: RelocationOrderSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[RelocationOrder] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[RelocationOrder] Set List Page';
  constructor(public Search: RelocationOrderSearchModel) { }
}

export class Set {
  static readonly type = '[RelocationOrder] Set';
  constructor(public Order: Models.Request<RelocationOrderModels.RelocationOrderModel>) { }
}

export class Get {
  static readonly type = '[RelocationOrder] Get';
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetStatusDictionary {
  static readonly type = '[RelocationOrder] Get Status Dictionary';
  constructor() { }
}

export class GetFilteredReport {
  static readonly type = '[RelocationOrder] GetFilteredReport';
  constructor(public Search: RelocationOrderSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[RelocationOrder] DisposeSearch';
  constructor() { }
}

export class GetPackageLabelPdf {
  static readonly type = "[RelocationOrder] Get Package Label PDF";
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetOrderProtocolPdf {
  static readonly type = "[RelocationOrder] Get Order Protocol PDF";
  constructor(public OrderId: Models.RequestModel) { }
}

export class GetParcelProtocolPdf {
  static readonly type = "[RelocationOrder] Get Parcel Protocol PDF";
  constructor(public ParcelId: Models.RequestModel) { }
}

export class New {
  static readonly type = '[RelocationOrder] New';
  constructor(public Order: Models.RequestNewOrder<TyreTakeoverOrderModels.TakeoverDepositesModel>) { }
}

export class GetTakoverTyreStateProtocolPdf {
  static readonly type = "[RelocationOrder] Get TakoverTyreState Protocol PDF";
  constructor(public TakoverTyreStateId: Models.RequestModel) { }
}
